export default {
  DATA_LAST_UPDATED_DATETIME: '2026-09-04 08:34',
  VALIDATION_STATUS_VALIDATED: 'VALIDATED',
  VALIDATION_STATUS_TO_VALIDATE: 'TO_VALIDATE',
  QUIZ_RELATIONSHIP_NEXT: 'suivant',
  QUIZ_RELATIONSHIP_SIMILAR: 'similaire',
  QUIZ_RELATIONSHIP_TWIN: 'jumeau',
  QUIZ_RELATONSHIP_TRANSLATION: 'traduction',
  QUIZ_SORT_DEFAULT: 'date_new',
  QUIZ_SORT_CHOICE_LIST: [
    { key: 'date_new', value: 'Plus récents' },
    // { key: 'date_old', value: 'Plus anciens' },
  ],
  LANGUAGE_CHOICE_LIST: [
    { code: 'fr', value: 'FRENCH', name: 'Français' },
    { code: 'en', value: 'ENGLISH', name: 'English' },
    { code: 'de', value: 'GERMAN', name: 'Deutsch' },
    { code: 'it', value: 'ITALIAN', name: 'Italiano' },
    { code: 'es', value: 'SPANISH', name: 'Español' },
  ],
  // DEFAULT_BACKGROUND_IMAGE_NAME: 'https://quizanthropocene.fr/showyourstripes_globe_1850-2019.png'
};
